import { render, staticRenderFns } from "./Health.vue?vue&type=template&id=665ff744&scoped=true&"
import script from "./Health.vue?vue&type=script&lang=ts&"
export * from "./Health.vue?vue&type=script&lang=ts&"
import style0 from "./Health.vue?vue&type=style&index=0&id=665ff744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665ff744",
  null
  
)

export default component.exports